export default class MapMathHelper {
    static normalizeAngle(angle, orientTop = false) {
        // we want our reference angle to be up |
        if (orientTop) {
            angle -= 90;
        }

        if (angle > 180) {
            return angle - 360;
        }
        if (angle < -180) {
            return angle + 360;
        }
        return angle;
    }

    static getDepartureDirection(angle) {
        angle = MapMathHelper.normalizeAngle(angle);
        // At departure, describe the area behind the user, not only near U-turns.
        if (angle <= -135) {
            return `backward-left`;
        }
        if (angle >= 135) {
            return `backward-right`;
        }
        return MapMathHelper.getAngleDirection(angle);
    }

    static getAngleDirection(angle) {
        angle = MapMathHelper.normalizeAngle(angle);
        if (angle < -160) {
            return `backward-left`;
        } else if (angle < -60) {
            return `left`;
        } else if (angle < -40) {
            return `light-left`;
        } else if (angle < 40) {
            return `forward`
        } else if (angle < 60) {
            return `light-right`;
        } else if (angle < 160) {
            return `right`;
        } else {
            return `backward-right`;
        }
    }
}
